import { Locale, type LocalizedString } from "../Locale.js";

export const productsAnchorPathMap = {
	[Locale.cs]: "#produkty" as const,
} satisfies LocalizedString;
